import { useEffect } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { useProgress, useSetProgress } from '@context/ProgressContext'
import MessageHelper from '@utils/messageHelper'
import useT from '@hooks/useTranslation'

const Form = ({ children, onSubmit, defaultValues, injectInForm, progressbar }) => {
    const methods = useForm({ defaultValues })
    const { handleSubmit, formState } = methods

    useEffect(() => {
        const isInvalid = formState.isSubmitted && !formState.isValid
        if (isInvalid) {
            const firstError = document.querySelector('[data-type="error"]')
            if (firstError) {
                firstError.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                })
            }
        }
    }, [formState.isSubmitted, formState.isSubmitting])

    const setProgress = progressbar && useSetProgress()
    const getProgress = progressbar && useProgress
    const progress = getProgress && getProgress()
    const trwaPrzesylanie = progressbar && useT('Zapis w tej chwili nie jest możliwy. Trwa przesyłanie plików na serwer')

    const submitHandler = progressbar
        ? (data) => {
            if (progress !== null) {
                return MessageHelper.message(trwaPrzesylanie + '.')
            }
            onSubmit(data)
          }

        : onSubmit

    return (
        <FormProvider {...methods} getProgress={getProgress} setProgress={setProgress}>
            <form onSubmit={handleSubmit(submitHandler)} noValidate>
                { children }
                { injectInForm }
            </form>
        </FormProvider>
    )
}

export default Form